import { animateBanners } from "./animations";
import initRegretForm from "./regretForm";
import initTotalsUpdateListener from "./totals";
import focusOnInputError from "./focusOnInputError";
import initSearchInput from "./searchInput";

const initComponents = () => {
    animateBanners();
    initRegretForm();
    initTotalsUpdateListener();
    focusOnInputError();
    initSearchInput();
};

export default initComponents;
